module.exports = __webpack_public_path__ + "img/style_model_preview_1.f4bc177e.jpg";